module.exports = __webpack_public_path__ + "img/story.986108e6.svg";